<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'myprofile'" [businessName]="vm.businessName" [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" *ngIf="!vm.isOpening">
  <div class="row section-header">
    <div class="col pt-4">Change Password</div>
  </div>
  <div>
    <hr class="mt-0" />
  </div>

  <div>
    <div class="row">
      <div class="col-xl-4 col-lg-5 col-md-6 pb-2">    

        <div class="row pb-1">
          <div class="col">
            <label>Password *</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('password')}" name="password"
              placeholder="" type="password" [(ngModel)]="vm.password">
            <div class="invalid-feedback"> {{error('password')}} </div>
          </div>
        </div>
        <div class="row pb-1">
            <div class="col">
              <label>Confirm Password *</label>
              <input class="form-control" [ngClass]="{'is-invalid': !!error('confirmPassword')}" name="confirmPassword"
                placeholder="" type="password" [(ngModel)]="vm.confirmPassword">
              <div class="invalid-feedback"> {{error('confirmPassword')}} </div>
            </div>
          </div>

          <div class="d-flex justify-content-end pt-4">
            <div><button class="btn btn-primary" style="width:6rem;" type="button" (click)="save()">Save</button></div>
            <div><button class="btn btn-link" style="width:6rem;" type="button" (click)="cancel()">Cancel</button></div>
          </div>
      </div>
    </div>
  </div>